import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <path d="M95.9 90c2.6-3 4.1-6.8 4.1-10.8 0-7.5-5-14-12.2-16 5-4.7 5.2-12.6.5-17.6-2.4-2.5-5.6-3.9-9.1-3.9 0-9.2-7.5-16.7-16.7-16.7-3.4.1-6.8-.5-10-1.7-5-2.3-9.8-7.5-2.5-19.2 0 0-15.6 4-23.9 16L7.1 1.3C5.5-.3 2.8-.3 1.2 1.3c-1.6 1.6-1.6 4.3 0 5.9l91.7 91.7c1.7 1.6 4.3 1.5 5.9-.2 1.5-1.6 1.5-4.1 0-5.7l-2.9-3zM8.3 54.2c0 3.4 1.4 6.7 3.9 9C3.4 65.7-1.8 74.8.6 83.7c2 7.2 8.6 12.2 16 12.2h55.7l-53.8-54c-5.9 1.2-10.2 6.3-10.2 12.3z" />
  </svg>
);
